import { AdditionalDefault, TreeCollection } from '@hh.ru/magritte-ui';

export const filterByExcludedValue = (
    collection: TreeCollection<AdditionalDefault>,
    value: string[],
    excludedValue: string[]
): string[] => {
    const result: string[] = [];
    const excludedSet = new Set(excludedValue);

    // обработка исключений для выключения соотвествующих элементов в дереве
    const processHasExcluded = (id: string): boolean => {
        const childrenIds = collection.getChildrenIds(id);
        return childrenIds.some((childId) => {
            if (excludedSet.has(childId)) {
                return true;
            }
            if (collection.hasChildren(childId)) {
                return processHasExcluded(childId);
            }
            return false;
        });
    };

    const processId = (id: string) => {
        if (collection.hasChildren(id)) {
            const childrenIds = collection.getChildrenIds(id);
            const hasExcluded = childrenIds.some((childId) => {
                if (excludedSet.has(childId)) {
                    return true;
                }
                return collection.hasChildren(childId) && processHasExcluded(childId);
            });

            if (hasExcluded) {
                for (const childId of childrenIds) {
                    if (!excludedSet.has(childId)) {
                        processId(childId);
                    }
                }
            } else {
                result.push(id);
            }
        } else {
            result.push(id);
        }
    };

    for (const id of value) {
        processId(id);
    }

    return result;
};
